export default [
    {
        path: '/CampusJobRecordList',
        name: 'CampusJobRecordList',
        component: resolve => require(['./CampusJobRecordList'], resolve)
    },
    {
        path: '/CampusJobRecordForm',
        name: 'CampusJobRecordForm',
        component: resolve => require(['./CampusJobRecordForm'], resolve)
    }
]


// WEBPACK FOOTER //
// ./src/components/campusJob/index.js